import React, { useState, useEffect } from 'react';
import RepairArticleCard from '../components/RepairArticleCard';
import LoadingSpinner from '../components/LoadingSpinner';
import ErrorAlert from '../components/ErrorAlert';
import api from '../services/api';
import { API_ENDPOINTS } from '../utils/constants';
import { FiSearch } from 'react-icons/fi';

const Repairs = () => {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [debouncedSearch, setDebouncedSearch] = useState('');

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(searchTerm);
    }, 500);

    return () => clearTimeout(timer);
  }, [searchTerm]);

  useEffect(() => {
    fetchArticles();
  }, [debouncedSearch]);

  const fetchArticles = async () => {
    try {
      setLoading(true);
      const params = {};
      if (debouncedSearch) params.search = debouncedSearch;
      
      const response = await api.get(API_ENDPOINTS.REPAIRS, { params });
      setArticles(response.data);
    } catch (err) {
      setError('មិនអាចផ្ទុកអត្ថបទបានទេ');
      console.error('Error fetching articles:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="max-w-7xl mx-auto px-4 py-8">
      {/* Header */}
      <div className="mb-8">
        <h1 className="text-2xl md:text-3xl font-bold text-gray-800 mb-2">
          អត្ថបទ<span className="text-red-600">ព័ត៌មាន</span>
        </h1>
        <p className="text-gray-600 text-sm">
          ស្វែងយល់អំពីផលិតផលញ៉ាំក្នុងស្រុក របៀបជ្រើសរើស និងអត្ថប្រយោជន៍សុខភាព
        </p>
      </div>

      {/* Search */}
      <div className="mb-8">
        <div className="relative max-w-md">
          <FiSearch className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} />
          <input
            type="text"
            placeholder="ស្វែងរកអត្ថបទ... (អង្ករ, ត្រី, បន្លែ, ផ្លែឈើ)"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="w-full pl-10 pr-4 py-2 border border-gray-200 bg-gray-50 text-gray-700 text-sm focus:outline-none focus:border-red-600 focus:bg-white"
          />
        </div>
      </div>

      {/* Results */}
      {loading ? (
        <div className="flex justify-center py-12">
          <LoadingSpinner />
        </div>
      ) : error ? (
        <ErrorAlert message={error} />
      ) : (
        <>
          <p className="mb-4 text-sm text-gray-500">
            បង្ហាញ <span className="font-semibold text-gray-700">{articles.length}</span> អត្ថបទ
          </p>
          
          {articles.length === 0 ? (
            <div className="text-center py-12 bg-gray-50 border border-gray-200">
              <p className="text-gray-500 text-base">រកមិនឃើញអត្ថបទ</p>
              {searchTerm && (
                <button
                  onClick={() => setSearchTerm('')}
                  className="mt-3 text-red-600 text-sm hover:text-red-700"
                >
                  សម្អាតការស្វែងរក
                </button>
              )}
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
              {articles.map((article) => (
                <RepairArticleCard key={article.id} article={article} />
              ))}
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default Repairs;